/** @format */
import { isObject } from '@toucan/common/services/application/helpers';

export function flattenObject(
    obj = {},
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-return, id-length -- Legacy code: do not use as an example.
    transformValue = (v: any) => v,
    parentKey = '',
    result = {}
) {
    for (const key in obj) {
        const keyName = parentKey ? `${parentKey}.${key}` : key;
        // @ts-ignore - Element implicitly has an any type - Touch and Change
        if (isObject(obj[key])) {
            // @ts-ignore - Element implicitly has an any type - Touch and Change
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example.
            flattenObject(obj[key], transformValue, keyName, result);
        } else {
            // @ts-ignore - Element implicitly has an any type - Touch and Change
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
            result[keyName] = transformValue(obj[key]);
        }
    }
    return result;
}
